import {
  createContext,
  useContext,
  useEffect,
  useReducer,
  useCallback,
  memo,
} from "react";
import { useRouter } from "next/router";
import styles from "@/styles/Copyrights.module.scss";

export const CopyrightsContext = createContext({
  copyrights: [],
  setCopyrights: () => null,
  resetCopyrights: () => null,
});
CopyrightsContext.displayName = "CopyrightsContext";

const initializeValue = [];
const reducer = (state, action) => {
  switch (action.type) {
    case "reset":
      return initializeValue;
    case "add":
      const newState = [...new Set(state.concat(action.value))];
      return newState.filter(Boolean);
    default:
      return state;
  }
};
export function CopyrightsProvider({ children }) {
  const [copyrights, dispatch] = useReducer(reducer, initializeValue);
  const setCopyrights = useCallback((value) => {
    dispatch({ type: "add", value });
  }, []);
  const resetCopyrights = useCallback(() => {
    dispatch({ type: "reset" });
  }, []);
  return (
    <CopyrightsContext.Provider
      value={{ copyrights, setCopyrights, resetCopyrights }}
    >
      {children}
    </CopyrightsContext.Provider>
  );
}

function Copyrights() {
  const router = useRouter();
  const { copyrights, resetCopyrights } = useContext(CopyrightsContext);

  useEffect(() => {
    const handleHistoryChange = () => {
      resetCopyrights();
    };
    router.events.on("routeChangeStart", handleHistoryChange);
    router.events.on("hashChangeStart", handleHistoryChange);
    return () => {
      router.events.off("routeChangeStart", handleHistoryChange);
      router.events.off("hashChangeStart", handleHistoryChange);
    };
  }, []);

  return (
    <div className={styles.copyrights}>
      <p className={styles.list}>
        {copyrights.map((c, i) => (
          <span key={`copyright-${i}`}>{c}</span>
        ))}
      </p>
    </div>
  );
}
export default memo(Copyrights);
